import { createReducer, on, StoreModule } from '@ngrx/store';
import { EffectLoadingState } from '../shared/models/effect-state';
import { EffectStateBase } from '../shared/models/effect-state-base';
import * as VehicleActions from '../vehicle/vehicle.actions';
import * as GarageActions from './garage.actions';

// This is definition of how state is stored/serialized in the store.

export const garageFeatureKey = 'garageState';

export interface GarageState extends EffectStateBase {
    activeGarageItemId: string;
}

export const initialState: GarageState = {
    activeGarageItemId: '',
    effectState: EffectLoadingState.Init,
};

export const garageReducer = createReducer(
    initialState,
    on(GarageActions.GetGarageItems, (state) => {
        return {
            ...state,
            effectState: EffectLoadingState.Loading,
        };
    }),
    on(GarageActions.GetGarageItemsSuccess, (state) => {
        return {
            ...state,
            effectState: EffectLoadingState.Loaded,
        };
    }),
    on(GarageActions.GetGarageItemsFail, (state, { errorMessage }) => {
        return {
            ...state,
            effectState: { errorMessage },
        };
    }),
    on(VehicleActions.AddVehicle, (state, { vehicle }) => {
        return {
            ...state,
            activeGarageItem: vehicle.id,
        };
    }),
    on(VehicleActions.DeleteVehicle, (state, { id }) => {
        return {
            ...state,
            activeGarageItem:
                state.activeGarageItemId === id ? '' : state.activeGarageItemId,
        };
    }),
    on(GarageActions.SetActiveGarageItemId, (state, { garageItemId }) => {
        return {
            ...state,
            activeGarageItemId: garageItemId,
        };
    })
);

export const garageStoreModule = StoreModule.forFeature(
    garageFeatureKey,
    garageReducer
);
